const URL = '/pws/v0/typeahead/graphql/'

const QUERY = `
  query nearbyAirports($value : NearbyAirportsRequest!){
    nearbyAirports(nearbyAirportsRequest: $value){
      matchedRegions{
        cityCode
        cityID
        cityName
        country
        countryCode
        displayName
        entered
        gmtOffset
        id
        itemName
        lat
        lon
        poiCategoryTypeId
        provinceName
        proximity
        rank
        score
        stateCode
        timeZoneName
        type
        nearbyAirports{
          cityCode
          cityID
          cityName
          country
          displayName
          entered
          gmtOffset
          id
          itemName
          lat
          lon
          poiCategoryTypeId
          provinceName
          proximity
          rank
          score
          stateCode
          timeZoneName
          type
        }
      }
    }
  }
`

export { URL, QUERY }
